import Modal from 'react-modal';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import '../server';
import './Confirmation.css';
import { toast } from 'react-toastify';
import { TransactionBlock } from '@mysten/sui.js';
import { TITLE_ID } from '../../Constants';
import { gaEvents } from '../../util/events';
import Logout from '../Logout/Logout';

/**
This is the confirmation modal for the import feature! This is different right now than the
Confirmation component since there are some differences, but if time,
definitely make the components reuseable so we don't have this messy code.
*/
function ImportConfirmation(props) {
  const {
    isShowLogin, // idk why I named it like this, can probably change the variable to just be for showModal since it
    // dictates whether the modal changes or not
    onCloseModal,
    nft, // the actual nft object,  has nft info like object id
    walletAddress, // the address that of the connected wallet, (probably redundant(can use wallet)
    refresh,
    wallet, // connected wallet
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [transferSuccess, setTransferSuccess] = useState(false);
  const [isTransferDisabled, setIsTransferDisabled] = useState(false);

  const [showLogout, setShowLogout] = useState(false);
  const [errorText, setErrorText] = useState(null);

  useEffect(() => {
    if (isShowLogin) {
      setShowModal(true);
    }
  });

  function handleCloseModal() {
    setShowModal(false);
    onCloseModal();
    setIsTransferDisabled(false);
    setTransferSuccess(false);
  }

  function toBytesArray(str) {
    const encoder = new TextEncoder();
    return encoder.encode(str);
  }

  // sleep time expects milliseconds
  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  function onShowLogout(errorText) {
    setErrorText(errorText);
    setShowLogout(true);
  }

  // johnx: add axios call here
  function importNft() {
    // console.log('import', nft.objectId, walletAddress, window.sessionStorage.getItem('entity_token'));
    setIsTransferDisabled(true);
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
        {
          FunctionName: 'CreateNftImportTransferContext',
          FunctionParameter: {
            ObjectId: nft.objectId, // nft.instanceId
            ItemInstanceId: nft.objectId,
            SourceWalletAddress: walletAddress,
          },
        },
        {
          headers: {
            'X-EntityToken': window.sessionStorage.getItem('entity_token'),
          },
        },
      ).then((response) => {
        // console.log(response, 'response');
        if (response.data.data.FunctionResult.message !== 'Success') {
          let errorMsg = 'Error importing, please try again';
          //EntityProfileConstraintValidationFailed = 1398
          if (response.data.data.FunctionResult.code === 1398) {
            errorMsg = response.data.data.FunctionResult.message;
            onShowLogout(response.data.data.FunctionResult.message);
          }
          toast.error(
            errorMsg,
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            },
          );
          gaEvents.importError();
        } else {
          const { transferContext } = response.data.data.FunctionResult.result;
          sleep(5000).then(() => {
            const txb = TransactionBlock.from(transferContext);
            wallet.signAndExecuteTransactionBlock({
              transactionBlock: txb,
              options: {
                showEffects: true,
                showEvents: true,
                showObjectChanges: true,
              },
            }).then((response) => {
              handleCloseModal();
              toast.success(
                'Imported Successfuly, you will now be able to see this in your game account',
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                },
              );
              gaEvents.importSuccess();
              // refresh();
            }).catch((e) => {
              console.log(e, 'error');
              toast.error(
                'Error importing, please try again',
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                },
              );
              gaEvents.importError();
              handleCloseModal();
            });
          });
        }
      }).catch(() => {
        toast.error(
          'Error importing, please try again',
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          },
        );
        handleCloseModal();
      });
  }

  return (
    <>
      {!transferSuccess
		&& (
<Modal
  ariaHideApp={false}
  isOpen={showModal}
  onRequestClose={handleCloseModal}
  contentLabel="Minimal Modal Example"
  className="confirmation-modal "
  overlayClassName="myoverlay"
  closeTimeoutMS={500}
>
<Logout
      isOpen={showLogout}
      logoutErrorText={errorText}
      />
  <div className="login-form">
    <div className="confirmation-form">
      {/* <h1>LOGIN</h1> */}
      <h1 className="transfer-header">Are You Sure?</h1>
      <h2 className="nft-name-confirmation">{nft.data ? nft.data.Title : ''}</h2>
      <img className="test-img" src={nft ? nft.imageUrl : ''} />
      <h2 className="transfer-text">
        The gear will be transferred to your game from your wallet. Make sure the following information is correct
        <br />
        {' '}
        <br />
      </h2>

      {!isTransferDisabled
      && (
      <button
        className="button transfer-button"
        onClick={importNft}
      >
        Import
      </button>
      )}
      {isTransferDisabled
      && (
      <button
        className="button transfer-button disabled"
      >
        Importing
      </button>
      )}

      <button
        className="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  </div>
</Modal>
		)}
      {transferSuccess
    	&& (
    <Modal
      ariaHideApp={false}
      isOpen={showModal}
      onRequestClose={handleCloseModal}
      contentLabel="Minimal Modal Example"
      className="confirmation-modal "
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
      <div className="login-form">
        <div className="confirmation-form">
          {/* <h1>LOGIN</h1> */}
          <h2 className="nft-name-confirmation">{nft.data.Title ?? 'empty name'}</h2>
          <img className="test-img" src={nft.data ? nft.data.ImageUrl : ''} />
          <h1 className="transfer-header">Transferred</h1>
          <h2>You now have this gear in your wallet.</h2>

          <button
            className="button"
            onClick={handleCloseModal}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
    	)}
    </>
  );
}

export default ImportConfirmation;
